import { render } from "./AnchorList.vue?vue&type=template&id=fef54510&scoped=true"
import script from "./AnchorList.vue?vue&type=script&lang=js"
export * from "./AnchorList.vue?vue&type=script&lang=js"

import "./AnchorList.vue?vue&type=style&index=0&id=fef54510&scoped=true&lang=css"

import exportComponent from "/Users/tomoiida/Dropbox/LegalNetwork/limar/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef54510"]])

export default __exports__